import { Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import Icon from 'components/Icon';

interface DocsNotificationDialogProps {
  open: boolean;
  onClose: () => void;
}

const DocsNotificationDialog = ({ open, onClose }: DocsNotificationDialogProps) => (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent>
        <Stack alignItems="center" gap={3} py={2}>
          <Icon icon="menu_book" fontSize="large" color="primary" />
          <Typography variant="h5" align="center">
            Welcome to Teleform! 🎉
          </Typography>
          <Typography variant="body1" align="center" color="text.secondary">
            We're excited to have you on board! To help you get started and make the most of Teleform's powerful features,
            we've prepared comprehensive documentation that will guide you through everything you need to know.
          </Typography>
          <Typography variant="body1" align="center" color="text.secondary">
            From creating your first bot to advanced automation features, our documentation has got you covered.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            href="https://www.teleform.io/docs/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClose}
            startIcon={<Icon icon="open_in_new" />}
          >
            Explore Documentation
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={onClose}
          >
            Continue to Dashboard
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );

export default DocsNotificationDialog;
